import React from 'react';
import {Route, Switch} from 'react-router-dom';
import App from './components/App';
import Home from './components/Home/Home';
import shrinkyprivacy from './pages/shrinkyprivacy';
import Error404 from './pages/Error404';
const AppRoutes = () => (
    <App>
        <Switch>
        <Route path="/" component={Home} exact/>
        <Route path="/shrinkyprivacy" component={shrinkyprivacy}/>
        <Route component={Error404} />
        </Switch>
    </App>
);

export default AppRoutes;